<template>
  <div class="flex flex-col">
    <div class="cat-top">
      <div class="cat-time-heading">Week Days </div>
    </div>
    <div class="day-picker flex flex-wrap justify-content-around day-row">
      <div class="flex-grow-1 flex flex-col px-2 py-4 day-item"
           :class="selected_days.includes(day_index) ? 'selected' : ''"
           @click="day_selected(day_index)" v-for="(day_index) in maxDays" :key="day_index">
        <div>{{getDayName(day_index)}}</div>
      </div>
    </div>
    <label class="pl-0 vs-input--label flex-1">(Select available days)</label>
  </div>
</template>

<script>
export default {
  name: 'WeekDayPicker',
  props: {
    selected_days: {
      type: Array
    },
    day_selected: {
      type: Function
    }
  },
  data () {
    return {
      maxDays: 6,
      picked_date: new Date(),
      show_calendar: false
    }
  },
  mounted () {
  },
  watch: {},
  computed: {},
  methods: {
    getDayName (index) {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      return days[index].substring(0, 3)
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  > div input {
    position: absolute;
    visibility: hidden;
  }
}
.vdp-datepicker__calendar {
  white-space: normal;
}
.day-row {
  justify-content: space-between;
  border: 1px solid #ccc;
  border-radius: 7px;
  flex: 4;
}
.day-item {
  flex: 1;
  cursor:pointer;

  &.selected {
    background-color:#13aa37;
    div{color:#fff;}
  }

  &:not(:last-child) {
    border-right: 1px solid #ccc;
  }
  div{
    color:#333;
    &:last-child{
      font-weight: 500;
    }
  }
  &:hover{
    background-color:#c6c6c6;
    div{color:#fff;}
  }
}
.hour-picker {
  border-top: 1px solid #ccc;
}
.hour-row {
  flex: 4;
  justify-content: space-between;
}
.hour-item {
  text-align: center;
  flex: 1;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding:10px 0px;
  cursor:pointer;
  &:hover{
    background-color:#f5f5f5
  }
  &.selected {
    background-color: #13aa37 !important;
    color: white;
    font-weight: 900;
  }

  &.past {
    background-color: #ebebeb;
    color: #ccc;
  }
  &:last-child {

    border-right: 1px solid #ccc;
  }
}
.cat-heading{
  text-align: left;
  padding:5px 0px;
  font-weight: 900;
}
.cat-top{
  padding:5px;
  margin-bottom:5px;
}
.cat-info{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:5px 0px;
  color:#000;
  .cat-info-col{
    &:first-child{
      font-weight: 600;
    }
    &:last-child{
      font-weight: 500;
      span:first-child{
        margin-right: 5px;
      }
      span:last-child{
        font-weight: 900;
      }
    }
  }
}
.cat-calendar-button{
  padding:5px 10px;
  width:max-content;
  background-color:#0070eb;
  color:#fff;
  font-weight: bold;
  border-radius: 7px;
  margin:10px auto;
  cursor:pointer;
  &:hover{
    background-color:#0263ce;
  }
}
.cat-time-heading{
  font-weight: 900;
  font-size:18px;
  text-align: left;
  color:#000;
}
.cat-time-buttons{
  display:flex;
  justify-content: space-between;
  margin:10px 0px;
  .cat-time-button{
    display:flex;
    align-items: center;
    justify-content: center;
    background-color:#0070eb;
    color:#fff;
    padding:5px 10px;
    width:max-content;
    border-radius: 7px;
    cursor:pointer;
    i {
      margin:0px 5px;
    }
  }
}
@media (max-width:768px){
  .cat-info{
    flex-wrap: wrap;
  }
  .hour-item {
    font-size:12px;
  }
}
</style>
